import React from 'react'
import Footer from '../components/Footer'
import MainCategory from '../components/MainCategory'
import Navigation from '../components/Navigation'

function Category() {
  return (
    <div>
      <Navigation />
      <MainCategory />
      <Footer />
    </div>
  )
}

export default Category